<template>
  <div class="drawer-wapper-info">
    <el-descriptions class="margin-top" :column="2" border>
      <el-descriptions-item :labelStyle="{ width: '110px' }">
        <template slot="label">
          {{ $l('form_label_expo_info_no') || '展会编号' }}
        </template>
        {{ formData.expoInfoNo || '' }}
      </el-descriptions-item>
      <el-descriptions-item :labelStyle="{ width: '110px' }">
        <template slot="label">
          {{ $l('form_label_expo_info_status') || '状态' }}
        </template>
        <el-tag
          size="mini"
          :type="
            formData.expoInfoStatus === 'D'
              ? 'danger'
              : formData.expoInfoStatus === 'N'
              ? 'light'
              : 'success'
          "
        >
          {{ formData.expoInfoStatusName || '' }}
        </el-tag>
      </el-descriptions-item>

      <el-descriptions-item :span="2" :labelStyle="{ width: '110px' }">
        <template slot="label">
          {{ $l('form_label_expo_info_name') || '展会名称' }}
        </template>
        <el-input
          v-model="formData.expoInfoName"
          :disabled="disabled"
          :placeholder="$l('tips_input_expoInfoName') || '请输入展会名称...'"
          maxlength="100"
          clearable
          size="small"
          style="width: 100%"
        ></el-input>
      </el-descriptions-item>

      <el-descriptions-item :span="2" :labelStyle="{ width: '110px' }">
        <template slot="label">
          {{ $l('form_label_expo_info_address') || '展会地点' }}
        </template>
        <el-input
          v-model="formData.expoInfoAddress"
          :disabled="disabled"
          :placeholder="$l('tips_input_expoInfoAddress') || '请输入展会地点...'"
          maxlength="100"
          clearable
          size="small"
          style="width: 100%"
        ></el-input>
      </el-descriptions-item>

      <el-descriptions-item :labelStyle="{ width: '110px' }">
        <template slot="label">
          {{ $l('form_label_begin_date') || '开始日期' }}
        </template>
        <el-date-picker
          v-model="formData.beginDate"
          :disabled="disabled"
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          :placeholder="$l('tips_select_begin_time') || '选择日期'"
          style="width: 100%"
        ></el-date-picker>
      </el-descriptions-item>
      <el-descriptions-item :labelStyle="{ width: '110px' }">
        <template slot="label">
          {{ $l('form_label_end_date') || '结束日期' }}
        </template>
        <el-date-picker
          v-model="formData.endDate"
          :disabled="disabled"
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          :placeholder="$l('tips_select_end_time') || '选择日期'"
          style="width: 100%"
        ></el-date-picker>
      </el-descriptions-item>

      <el-descriptions-item :span="2" :labelStyle="{ width: '110px' }">
        <template slot="label">
          {{ $l('form_label_expo_manager_name') || '负责人' }}
        </template>
        <dict-select
          v-model="formData.expoManagerCode"
          :selectedLabel.sync="formData.expoManagerName"
          :disabled="disabled"
          url="/master/common/dict/baseUserSelect"
          :placeholder="$l('tips_select_expoManager') || '请选择负责人...'"
          size="small"
          clearable
          filterable
          style="width: 50%"
        ></dict-select>
      </el-descriptions-item>

      <el-descriptions-item :span="2" :labelStyle="{ width: '110px' }">
        <template slot="label">
          {{ $l('form_label_participants') || '参与人' }}
        </template>
        <dict-select
          v-model="formData.participantsArray"
          url="/master/common/dict/baseUserSelect"
          size="small"
          :placeholder="
            $l('tips_select_participantsArray') || '请选择参与人...'
          "
          :disabled="disabled"
          clearable
          filterable
          multiple
          :options="{ label: 'label', value: 'this' }"
        ></dict-select>
      </el-descriptions-item>

      <el-descriptions-item :labelStyle="{ width: '110px' }" v-if="disabled">
        <template slot="label">
          {{ $l('form_label_created_by') || '创建人' }}
        </template>
        {{ formData.createByName || '' }}
      </el-descriptions-item>
      <el-descriptions-item :labelStyle="{ width: '110px' }" v-if="disabled">
        <template slot="label">
          {{ $l('form_label_created_date') || '创建时间' }}
        </template>
        {{ formData.createDate || '' }}
      </el-descriptions-item>

      <el-descriptions-item :labelStyle="{ width: '110px' }" v-if="disabled">
        <template slot="label">
          {{ $l('form_label_modified_by') || '修改人' }}
        </template>
        {{ formData.modifyByName || '' }}
      </el-descriptions-item>
      <el-descriptions-item :labelStyle="{ width: '110px' }" v-if="disabled">
        <template slot="label">
          {{ $l('form_label_modification_time') || '修改时间' }}
        </template>
        {{ formData.modifyDate || '' }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="d-flex justify-content-end mt-4 mb-2" v-if="!disabled">
      <el-button type="primary" size="small" @click="save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </div>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    expoInfoCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {
        expoInfoStatus: 'N',
        expoInfoStatusName: this.$l('btn_status_N') || '新增',
      },
      backDialogVisible: false,
      chooseCollectionVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.expoInfoCode) return
      this.$api
        .expoInfoDetailApi({
          expoInfoCode: this.expoInfoCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    async save() {
      this.loadingOpen()
      console.log(this.formData)
      this.$api
        .expoInfoSaveApi(this.formData)
        .then(async (res) => {
          this.loadingClose()
          const { status } = res
          if (status !== 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
            return
          }
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || '保存成功！',
            type: 'success',
          })
          await this.closeCurPage()
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async closeCurPage() {
      // 关闭当前页面
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-wapper-info {
  padding: 0 30px;
}
</style>
